import React, { useState } from 'react';
import Root_Header from './Root_Header';
import Root_Content from './Root_Content';
import Root_Footer from './Root_Footer';
import { useSnackbar } from '../component/SnackbarContext'; 
import Print_Snackbar_inline from '../component/Print_Snackbar_inline';

function Root_Page({ activeTheme, clientid, invoiceid,language, setActiveTheme, simpleClient, simpleTheme, selectedLayout }) {
  const { addSnackbar } = useSnackbar();

  const [cart, setCart] = useState([{ index: 3, count: 1 },{ index: 8, count: 2 },{ index: 5, count: 1 },{ index: 6, count: 1 }]);
  const [recent, setRecent] = useState([{ index: 4, count: 1 }]);
  
  const addToCart = (index, mycount=1) => {
    if (index !== undefined && index !== null && !isNaN(index)) {
      const existingCartItem = cart.find(item => item.index === index);
      const existingRecentItem = recent.find(item => item.index === index);

      if (existingCartItem) {
        const updatedCart = cart.map(item =>
          item.index === index ? { ...item, count: item.count + 1 } : item
        );
        setCart(updatedCart);
        addSnackbar('Already in cart. Quantity incremented.', { severity: 'info', variant:'filled', icon:false });   
        const favoriteLink = document.getElementById('cart');
        favoriteLink.classList.add('bg-theme-accent');       
        setTimeout(() => { favoriteLink.classList.remove('bg-theme-accent');}, 1100);
      } else {
        // If the index is in the recent array, remove it from recent
        if (existingRecentItem) {
          removeFromRecent(index);
        }
        setCart([...cart, { index, count: mycount }]);
        addSnackbar('Added to cart.');
        const favoriteLink = document.getElementById('cart');
        favoriteLink.classList.add('blinkme', 'bg-theme-accent');       
        setTimeout(() => { favoriteLink.classList.remove('blinkme', 'bg-theme-accent');}, 1100);
      }
    }
  };
  const increaseQuantity = (index) => {
    const updatedCart = cart.map(item =>
      item.index === index ? { ...item, count: item.count + 1 } : item
    );
    setCart(updatedCart);
  };
  
  const decreaseQuantity = (index) => {
    const updatedCart = cart.map(item =>
      item.index === index ? { ...item, count: Math.max(1, item.count - 1) } : item
    );
    setCart(updatedCart);
  };
  
  const addToRecent = (index, mycount) => {
    if (index !== undefined && index !== null && !isNaN(index)) {
      const existingRecentItem = recent.find(item => item.index === index);
  
      if (!existingRecentItem) {
        // Add the new item to the beginning of the recent array
        setRecent([{ index, count: mycount }, ...recent]);
        
      }
    }
  };

  const removeFromCart = (indexToRemove, mycount) => {
    const updatedCart = cart.filter(item => item.index !== indexToRemove);
    setCart(updatedCart);
    addToRecent(indexToRemove, mycount);
  };

  const removeFromRecent = (indexToRemove) => {
    const updatedRecent = recent.filter(item => item.index !== indexToRemove);
    setRecent(updatedRecent);
  };

  const [favorites, setFavorites] = useState([3, 5, 9, 13]);
  const isInFavorites = (index) => {return favorites.includes(index);};// Function to check if a product is in favorites
    // Function to add a product to favorites
    const addToFavorites = (index) => {
      if (!isInFavorites(index)) {
        setFavorites([...favorites, index]);   
        const favoriteLink = document.getElementById('favorite');
        favoriteLink.classList.add('blinkme');       
        setTimeout(() => { favoriteLink.classList.remove('blinkme');}, 1100);
  
      }else{/*  */
        addSnackbar('Already available', { severity: 'info', variant:'filled', /* CSS:'background-color:white;',  */icon:false });
      };
    };
  const removeFromFavorites = (index) => {setFavorites(favorites.filter((item) => item !== index));};
  

  return (
    <div className="">
      <Root_Header
        cart={cart}
        removeFromCart={removeFromCart}
        addToCart={addToCart}
        increaseQuantity={increaseQuantity}
        decreaseQuantity={decreaseQuantity}
        favorites={favorites}
        removeFromFavorites={removeFromFavorites}
        recent={recent}
        addToRecent={addToRecent}
        removeFromRecent={removeFromRecent}
      />
      <Root_Content addToCart={addToCart} addToFavorites={addToFavorites} />    
      <Root_Footer /> 
      {/* <Print_Snackbar_inline/> */}
    </div>
  );
};

export default Root_Page;